import { api, ApiRequestConfig } from './api';
import { DeliveryMinPriceParams } from 'types/delivery-min-price';

export const getDeliveryMinPrice = ({ regionId }: DeliveryMinPriceParams, config: ApiRequestConfig) =>
  api.get<string>(`delivery-min-price/${regionId}`, {}, config);
